module.exports = __webpack_public_path__ + "img/banner_home2.1b4d9449.png";